import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import { updatedToken } from '../actions/realtime';

export default handleActions<DamzState['realtime'], any>(
  {
    [`${updatedToken}`]: (state, action) => ({
      ...state,
      token: action.payload.token,
      expiresAt: action.payload.expiresAt,
      waitingForToken: action.payload.waitingForToken,
    }),
  },
  {
    token: undefined,
    expiresAt: undefined,
    waitingForToken: undefined,
  }
);
